if (!customElements.get("gallery-dots")) {
  class GalleryDots extends HTMLElement {
    connectedCallback() {
      this.dots = Array.from(this.querySelectorAll(".gallery-dot"));
      if (!this.dots.length) return;

      // The slider list is identified by the data-slider-id attribute on this element.
      const sliderId = this.dataset.sliderId;
      this.slider = sliderId ? document.getElementById(sliderId) : null;

      if (this.slider) {
        this.slides = Array.from(this.slider.children);
        this._bindScrollObserver();
      }

      // Also respond to programmatic slideChanged events dispatched on the slider-component parent.
      const sliderComponent = this.closest("slider-component");
      if (sliderComponent) {
        sliderComponent.addEventListener("slideChanged", (e) => {
          const index = this.slides
            ? this.slides.indexOf(e.detail.currentElement)
            : -1;
          if (index >= 0) this.setActive(index);
        });
      }
    }

    _bindScrollObserver() {
      // Use IntersectionObserver to detect which slide is snapped into view.
      const options = {
        root: this.slider,
        threshold: 0.5,
      };
      this._observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = this.slides.indexOf(entry.target);
            if (index >= 0) this.setActive(index);
          }
        });
      }, options);

      this.slides.forEach((slide) => this._observer.observe(slide));
    }

    setActive(index) {
      this.dots.forEach((dot, i) =>
        dot.classList.toggle("active", i === index)
      );
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
    }
  }

  customElements.define("gallery-dots", GalleryDots);
}
